export const STATS = [
  {
    key: 'str',
    label: 'Strength',
    description: 'Physical power and carrying capacity.'
  },
  {
    key: 'dex',
    label: 'Dexterity',
    description: 'Agility, reflexes, and balance.'
  },
  {
    key: 'con',
    label: 'Constitution',
    description: 'Endurance and stamina.'
  },
  {
    key: 'int',
    label: 'Intellect',
    description: 'Reasoning and memory.'
  },
  {
    key: 'wis',
    label: 'Wisdom',
    description: 'Perception and insight.'
  },
  {
    key: 'cha',
    label: 'Charisma',
    description: 'Force of personality.'
  }
];

export default STATS;

